import { c as _c } from "react/compiler-runtime";
import React from 'react';
interface PropTypes {
  onClick?: (event?: React.MouseEvent<HTMLButtonElement>) => void;
  icon: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}
const ButtonWithIcon: React.FC<PropTypes> = t0 => {
  const $ = _c(7);
  const {
    icon,
    onClick,
    children,
    className
  } = t0;
  const t1 = `flex flex-row items-center px-4 h-[40px] rounded-md bg-red-600 hover:bg-red-500 ${className}`;
  let t2;
  if ($[0] !== children) {
    t2 = <span className="text-white ml-2 font-bold">{children}</span>;
    $[0] = children;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== icon || $[3] !== onClick || $[4] !== t1 || $[5] !== t2) {
    t3 = <button className={t1} onClick={onClick}>{icon}{t2}</button>;
    $[2] = icon;
    $[3] = onClick;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default ButtonWithIcon;